export class SendActivityApiRequest {
  before = "";
  after = "";
  // Optional header value used by the API repository to set the X-Activity header
  activityHeader = "";

  constructor(fields?: Partial<SendActivityApiRequest>) {
    Object.assign(this, fields);
  }

  toJSON() {
    // Exclude header from body payload
    return JSON.stringify({
      before: this.before,
      after: this.after
    });
  }
}

